export enum AssignEmployersMode {
	EmailTemplate = 1,
	ActionItemsTemplate = 2,
	ActionItem = 3,
	LeaveReason = 4
}